import { Component } from '@angular/core';
import { registerIonicons } from './core/icons/icon-registry';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor() {
    registerIonicons();
  }
}
